import { HashRouter, BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import idID from 'antd/locale/id_ID';
import { useAuthStore, clearAuthDataOnStartup } from '@/modules/auth/authStore';
import { antdTheme } from '@/theme';
import { MainLayout } from '@/components/layout';
import LoginPage from '@/modules/auth/LoginPage';

// Desktop mode (Electron) menggunakan HashRouter karena file:// protocol
// SaaS mode (Browser) menggunakan BrowserRouter untuk clean URLs
const isDesktopMode = import.meta.env.VITE_MODE === 'Desktop';
const Router = isDesktopMode ? HashRouter : BrowserRouter;

// KEAMANAN: Hapus data autentikasi lama saat aplikasi startup
// User harus login ulang setiap kali membuka aplikasi
clearAuthDataOnStartup();

// Protected route wrapper - cek autentikasi
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

// Layout wrapper for authenticated pages
function AuthenticatedLayout() {
  return (
    <ProtectedRoute>
      <MainLayout />
    </ProtectedRoute>
  );
}

/**
 * App Component
 *
 * Routing sederhana dengan sistem tab aplikasi:
 * - /login: Halaman login (public)
 * - /*: Semua route lain di-handle oleh MainLayout dengan sistem tab
 *
 * MainLayout akan:
 * 1. Baca path dari URL
 * 2. Buka tab sesuai path (jika belum terbuka)
 * 3. Render semua tab yang terbuka (hidden jika tidak aktif)
 * 4. Sync URL dengan tab aktif
 */
function App() {
  return (
    <ConfigProvider locale={idID} theme={antdTheme}>
      {/* AntdApp wrapper diperlukan untuk menggunakan App.useApp() hook */}
      {/* Ini memungkinkan message/notification/modal mengakses theme context */}
      <AntdApp>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected routes dengan sistem tab */}
            {/* MainLayout handle semua path dan render halaman sesuai tab */}
            <Route path="/*" element={<AuthenticatedLayout />} />
          </Routes>
        </Router>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
